import { useRef, useState } from 'react'
import { useBreakpoints, useView } from '@10000/react'
import { Body, Box, Pill, IconButton, Button, SelectButtons, ElementHighlight } from '../widgets'
import { FiltersDrawer, useAnalyticsData } from '.'
import { industries, isFree, levels, roles } from '../../lookups'

export const Controls = ({ displayMode }) => {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const { teams = [], subscription } = useView('tenant')

  const { mode, setMode, active, filters: { teamId, compareConsensus, industry, role, level }, setFilters, removeFilter } = useAnalyticsData()

  const activeTeams = teams.filter(x => x.squizCount > 0)
  const { name } = teams.find(x => x.id === teamId) || {}
  const compare = mode === 'compare'
  const modeRef = useRef()
  const consensusRef = useRef()
  const desktopFiltersRef = useRef()
  const mobileFiltersRef = useRef()
  const { mobile } = useBreakpoints()

  const openFilters = () => setFiltersOpen(true)

  return (
    <Box fullWidth justifyContent="space-between" px={32} gap={8} className="controls">
      {!displayMode && (
        <>
          <Box gap={8} grow maxWidth={400}>
            <Button smallOnMobile width="50%" light={mode === 'yourData'} onClick={() => setMode('yourData')}>
              Your&nbsp;data
            </Button>
            <Button ref={modeRef} smallOnMobile width="50%" light={mode === 'compare'} onClick={() => setMode('compare')}>
              Compare
            </Button>
            <Box className="mobile-only">
              <IconButton ref={mobileFiltersRef} small round icon="Filter" size={24} onClick={openFilters} />
            </Box>
          </Box>

          <FiltersDrawer open={filtersOpen} onClose={() => setFiltersOpen(false)} />
        </>
      )}

      <Box gap={24}>
        {compare && !displayMode && (!isFree(subscription) || active.consensus?.some(x => !!x)) &&
          <>
            <SelectButtons
              selectedIndex={compareConsensus ? 1 : 0}
              items={['Global data', 'Consensus mode']}
              onClick={index => setFilters({ compareConsensus: index === 1 })}
              ref={consensusRef}
              buttonRefIndex={1}
            />
            <ElementHighlight
              order={5}
              target={consensusRef}
              pointDirection={mobile ? 'up' : 'right-up'}
              nextOnFinish
            />
          </>
        }
        <Box gap={8} className="desktop-only" wrap>
          {activeTeams.length > 1 &&
            <FilterPill filter="Team" value={name} />
          }
          <FilterPill filter="Industry" value={industries[industry]?.name} onRemove={() => removeFilter('industry')} />
          <FilterPill filter="Function" value={roles[role]?.name} onRemove={() => removeFilter('role')} />
          <FilterPill filter="Level" value={levels[level]?.name} onRemove={() => removeFilter('level')} />

          {((compare || activeTeams.length > 1) && !displayMode) &&
            <Button
              background="black"
              color="white"
              leftIcon="Filter"
              onClick={openFilters}
              cursor="pointer"
              ref={desktopFiltersRef}
            >
              <Body alt bold>Filters</Body>
            </Button>
          }
        </Box>
      </Box>

      {compare
        ? <ElementHighlight
            order={1}
            target={mobile ? mobileFiltersRef : desktopFiltersRef}
            pointDirection="right-up"
            nextOnFinish
          />
        : <ElementHighlight
            order={10}
            target={modeRef}
            pointDirection={mobile ? 'up' : 'left-up'}
            nextOnFinish
          />
      }
    </Box>
  )
}

const FilterPill = ({ filter, value, onRemove }) => (value || typeof value === 'number') && (
  <Pill
    background="rgba(255, 255, 255, 0.2)"
    height={56}
    r={28}
    color="white"
    maxWidth={300}
    rightIcon={onRemove && 'Close'}
    onRightIconClick={onRemove}
  >
    <Body alt>{filter}: <Body alt bold>{value}</Body></Body>
  </Pill>
)